import React, { useState } from "react";
import { Row, Col, Input, Button, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GenerateQuestionsModal from "../Modal/GenerateQuestionsModal";
import ShowFinalExamModal from "../Modal/ShowFinalExamModal";
import { FormattedMessage } from "react-intl";
import { GetProgramById } from "../../actions/teacherQueries";

export default function FinalExamUnlocker(props) {
  const [isGenerateModalOpen, setIsGenerateModalOpen] = useState(false);
  const [showFinalExamModal, setShowFinalExamModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const programInfo = GetProgramById(props.programId);

  const toggleGenerateModal = () => {
    setIsGenerateModalOpen(!isGenerateModalOpen);
  };

  const handleOpenGenerateModal = (course) => {
    setSelectedCourse(course);
    setIsGenerateModalOpen(true);
  };

  const toggleShowFinalExamModal = () => {
    setShowFinalExamModal(!showFinalExamModal);
  };

  const handleShowFinalExamModal = (course) => {
    setSelectedCourse(course);
    setShowFinalExamModal(true);
  };

  const mappedCourses = () => {
    if (props.courses) {
      return props.courses.map((course, i) => (
        <Col key={i} xs={12} className="mt-1 px-2 px-md-3">
          <div
            className="d-flex flex-column flex-md-row align-items-center justify-content-between p-2"
            style={{ border: "1px solid #c2cfd6" }}
          >
            <div
              style={{
                width: "115px",
                height: "65px",
                backgroundImage: "url(" + encodeURIComponent(course.imgUrl) + ")",
                backgroundSize: "contain",
              }}
              className="ms-3 me-3"
            ></div>

            <div className="flex-grow-1 px-2 ps-0 my-auto ms-2">
              <p className="lead mb-auto">{course.name}</p>
            </div>

            {course.hasGy25FinalExam ? (
              <div className="d-flex flex-column gap-2 ">
                <Button
                  outline
                  color="primary"
                  className="flex-grow-1 px-3 py-1 mb-1 w-20"
                  onClick={() => handleOpenGenerateModal(course)}
                >
                  <FormattedMessage id="CreateExam" />
                </Button>
                <Button
                  outline
                  color="primary"
                  className="flex-grow-1 px-3 py-1 w-20"
                  onClick={() => handleShowFinalExamModal(course)}
                >
                  <FormattedMessage id="ShowExam" />
                </Button>
              </div>
            ) : (
              <div className="d-flex align-items-center ms-3 me-3">
                <div className="form-check form-switch rounded">
                  <Input
                    style={{ marginTop: ".3em" }}
                    type="switch"
                    id={"activate_switch_" + i}
                    className="form-switch me-1 rounded"
                    checked={course.finalExamEnabled}
                    name={"activate_switch_" + i}
                    onChange={(event) =>
                      props.handleLockUnlockFinalExam(event, course)
                    }
                  />
                  <Label for={"activate_switch_" + i} className="mb-0">
                    {course.finalExamEnabled ? (
                      <span style={{ width: "20px", display: "inline-block" }}>
                        <FontAwesomeIcon
                          icon="lock-open"
                          className="text-primary"
                          size="lg"
                        />
                      </span>
                    ) : (
                      <span style={{ width: "20px", display: "inline-block" }}>
                        <FontAwesomeIcon
                          icon="lock"
                          className="text-muted"
                          size="lg"
                        />
                      </span>
                    )}
                  </Label>
                </div>
              </div>
            )}
          </div>
        </Col>
      ));
    }
  };

  return (
    <>
      <Row>{mappedCourses()}</Row>
      <GenerateQuestionsModal
        classId={props.classId}
        course={selectedCourse}
        studentCoursesModules={props.studentCoursesModules}
        student={props.student}
        isOpen={isGenerateModalOpen}
        toggle={toggleGenerateModal}
        classes={programInfo.data?.classes}
        level={props.level}
      />
      <ShowFinalExamModal
        classId={props.classId}
        courseId={selectedCourse?.id}
        courseName={selectedCourse?.name || selectedCourse?.courseName}
        course={selectedCourse}
        student={props.student}
        isOpen={showFinalExamModal}
        toggle={toggleShowFinalExamModal}
        level={props.level}
      />
    </>
  );
}
